import { IgUser, IgUser2 } from '@core/models/ApiFields/ig-entities';

export const userDetailFields = [
    IgUser.getPrefixed('name'),
    IgUser.getPrefixed('username'),
    IgUser.getPrefixed('image'),
    IgUser.getPrefixed('biography'),
    IgUser.getPrefixed('followers'),
    IgUser.getPrefixed('follows'),
    IgUser.getPrefixed('influencer'),
    IgUser.getPrefixed('website'),
    IgUser.getPrefixed('mediaCount'),
];

export const relatedUsersFields = [IgUser2.getPrefixed('image'), IgUser2.getPrefixed('username')];
